module.exports = __webpack_public_path__ + "img/teacher.5bd8f91d.png";